import React, { useContext } from "react"
import { graphql, useStaticQuery } from "gatsby"

import Grid from "../shared/grid"
import Link from "../shared/link"
import { UIContext } from "../shared/layout"
import {
  Background,
  StyledFluid,
  DetailsWrapper,
  Title,
  Body,
  linkStyle,
} from "./map-editor.style"

const MapEditor = () => {
  const { mapEditorDesktopImage, mapEditorMobileImage } =
    useStaticQuery(graphql`
      query {
        mapEditorDesktopImage: file(
          relativePath: {
            eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Analytics Dashboard/map_editor_desk.png"
          }
        ) {
          childImageSharp {
            fluid(maxWidth: 1440, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        mapEditorMobileImage: file(
          relativePath: {
            eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Analytics Dashboard/map_editor_mobile.png"
          }
        ) {
          childImageSharp {
            fluid(maxWidth: 1440, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `)
  const { state: UIState } = useContext(UIContext)
  return (
    <Background>
      <Grid>
        <StyledFluid
          fluid={
            UIState.breakpoint === "sm"
              ? mapEditorMobileImage.childImageSharp.fluid
              : mapEditorDesktopImage.childImageSharp.fluid
          }
          alt="A laptop showing the Mappedin Map Editor."
        />
        <DetailsWrapper>
          <Title>Map Editor</Title>
          <Body>
            Edit your property maps and location data with Mappedin’s Map
            Editor, ensuring your visitors are always up-to-date.
          </Body>
          <Link href="/mapping/map-editor/" styleModifier={linkStyle}>
            Explore Map Editor
          </Link>
        </DetailsWrapper>
      </Grid>
    </Background>
  )
}

export default MapEditor
